import type { AxiosRequestConfig } from 'axios';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import {
  MarketFacilityFormResponseDtoSchema,
  type MarketFacilityFormResponseDto,
} from '../contracts';

export type GetMarketFacilityFormByIdResponseDto =
  MarketFacilityFormResponseDto;

export const getMarketFacilityFormById = (
  formId: number,
  config?: AxiosRequestConfig
) => {
  return api
    .get(`/market-facilities/form/${formId}`, config)
    .then(responseContract(MarketFacilityFormResponseDtoSchema));
};
